module.exports = "<universal-page></universal-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appUniversal.html
// module id = 1592
// module chunks = 0